<template>
  <div class="c-modal">
    <div class="c-container">
      <a @click="$emit('close')">close</a>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  mounted() {
    bus.$on("closeModal", () => {
      this.$emit("close");
    });
  },
};
</script>
